import { render, staticRenderFns } from "./PrognoseVinculada.vue?vue&type=template&id=441ac8a0&scoped=true"
import script from "./PrognoseVinculada.vue?vue&type=script&lang=js"
export * from "./PrognoseVinculada.vue?vue&type=script&lang=js"
import style0 from "./PrognoseVinculada.vue?vue&type=style&index=0&id=441ac8a0&prod&lang=css"
import style1 from "../../../css/crud.css?vue&type=style&index=1&id=441ac8a0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441ac8a0",
  null
  
)

export default component.exports